<template>
  <div class="OfferCardActionForward" @click.stop="$emit('click')">
    <BaseIcon size="sm" name="menu-right-mono" />
  </div>
</template>

<script>
import BaseIcon from '~/aasgard/components/base/BaseIcon.vue'

export default {
  name: 'OfferCardActionForward',
  components: { BaseIcon },
  emits: ['click'],
}
</script>

<style lang="scss">
.OfferCardActionForward {
  display: flex;
  flex-direction: row;
  gap: 0;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  position: relative;
  cursor: pointer;
  border-radius: 50%;
  overflow: hidden;

  &:not([disabled]) {
    @include hover-default;
  }

  & > .BaseIcon {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    position: relative;
    overflow: visible;

    @include setSVGMonoColor($color-black-medium);
  }
}
</style>
